module.exports = __webpack_public_path__ + "img/005.8b0c7a04.jpg";